module.exports = __webpack_public_path__ + "assets/profile-shadow.png?61dce96893e5f1553f036162af4422c2";